export interface NotificationUrlInfo {
  id: string;
  action: string;
}
export default function UrlHelper() {
  return {
    notification() {
      return {
        clearHash() {
          window.location.hash = "";
        },
        createUrlHash(baseUrl: string, id: string, action: string = "") {
          if (!action) {
            action = "view";
          }
          return `${baseUrl}#id=${id}&action=${action}`;
        },
        createUrlQuery(baseUrl: string, id: string, action: string = "", pickerey: string = "id") {
          if (!action) {
            action = "view";
          }
          return `${baseUrl}?${pickerey}=${id}&action=${action}`;
        },
        getUrlHashItems(): NotificationUrlInfo {
          const hash = window.location.hash.slice(1); // Remove the "#" symbol
          const params = new URLSearchParams(hash); // Parse the hash part
          // Convert hash items into an array of {key, value} objects
          let hashItems = {
            id: "",
            action: "",
          } as NotificationUrlInfo;
          for (const [key, value] of params.entries()) {
            if (key === "id") {
              hashItems.id = value as string;
            } else if (key === "action") {
              hashItems.action = value as string;
            }
          }
          this.clearHash();
          return hashItems;
        },
      };
    },
  };
}
